import React from 'react';
import "~/sass/modules/_simSelection.scss";
import { Link } from "#/renderer/router";

const SimSelection = ({
  esimDetail,
  simType,
  selectedSimType = null,
  onChageSimType = () => { },
  fixed = false,
  containerStyles = {},
  onClickLink = null
}) => {

  const data = esimDetail;

  if (!data) return null;

  // Show the two sim selection options, a case to use this is for postpaid withoout terminal
  if (fixed) {

    React.useEffect(() => {

      setTimeout(() => {
        const openTerminalLink = document.getElementById('open-terminals-modal');
        if (openTerminalLink) {
          openTerminalLink.addEventListener('click', () => {
            onClickLink ? onClickLink() : null;
          })
        }


      }, 100);

    }, [data.details.info.label])

    return (
      <div className='simselection' style={{ ...containerStyles }}>

        <p className='simselection--title'>{data.title}</p>

        <div className="simselection--options">
          <label>
            <input type="radio" name="esim" value={data.eSim.value} checked={selectedSimType === data.eSim.value}
              onChange={() => onChageSimType(data.eSim.value)}
            />
            <span>{data.eSim.label}</span>
          </label>
          <label>
            <input type="radio" name="nanosim" value={data.nanoSim.value} checked={selectedSimType === data.nanoSim.value}
              onChange={() => onChageSimType(data.nanoSim.value)}
            />
            <span>{data.nanoSim.label}</span>
          </label>
        </div>

        {
          ['ESIM'].includes(selectedSimType) && (
            <div className="grid">
            <div className="icon-container">
              <span className='icon-info'>i</span>
            </div>
            <div>
              <p className='text'>
                <div dangerouslySetInnerHTML={{ __html: data.details.info.label }}></div>
              </p>
            </div>
          </div>
          )
        }
      </div>
    )

  }



  return (
    <div className='simselection'>


      <p className='simselection--title'>{ simType === 'ESIM' ? data?.titleOnlyWithEsim : data?.title}</p>

      <div className="simselection--options">
        {
          ['AMBAS'].includes(simType) && (
            <label>
              <input type="radio" name="esim" value={data.eSim.value} checked={selectedSimType === data.eSim.value}
                onChange={() => onChageSimType(data.eSim.value)}
              />
              <span>{data.eSim.label}</span>
            </label>
          )
        }

        {
          ['AMBAS'].includes(simType) && (
            <label>
              <input type="radio" name="nanosim" value={data.nanoSim.value} checked={selectedSimType === data.nanoSim.value}
                onChange={() => onChageSimType(data.nanoSim.value)}
              />
              <span>{data.nanoSim.label}</span>
            </label>
          )
        }
      </div>

      {
          ['ESIM'].includes(selectedSimType) && (
          <div className="grid">
          <div className="icon-container">
            <span className='icon-info'>i</span>
          </div>
          <div>
            <p className='text'>
              <span dangerouslySetInnerHTML={{ __html: data.details.info.label }} />
            </p>
          </div>
        </div>
        )
      }

    </div>
  )

}


export default SimSelection
